import { Badge } from '@/components/ui';
import { AuditLogActionEnum } from '@/enums';

interface ActionBadgeProps {
	action: AuditLogActionEnum;
}

const ACTION_CONFIG: Record<AuditLogActionEnum, { label: string; className: string }> = {
	[AuditLogActionEnum.CREATE]: {
		label: 'Créé',
		className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400 border-green-200'
	},
	[AuditLogActionEnum.UPDATE]: {
		label: 'Modifié',
		className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400 border-blue-200'
	},
	[AuditLogActionEnum.DELETE]: {
		label: 'Supprimé',
		className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400 border-red-200'
	}
};

export const ActionBadge = ({ action }: ActionBadgeProps) => {
	const config = ACTION_CONFIG[action] ?? { label: action, className: '' };
	return (
		<Badge variant="outline" className={`text-xs font-medium ${config.className}`}>
			{config.label}
		</Badge>
	);
};
